import React from "react";
import { twMerge } from "tailwind-merge";

export interface IconButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  Icon: JSX.Element;
}

const IconButton = React.forwardRef<HTMLDivElement, IconButtonProps>(
  ({ Icon, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={twMerge(
          "w-10 h-10 p-2 cursor-pointer hover:bg-neutral-op-8 rounded-md flex justify-center items-center",
          className
        )}
        {...props}
      >
        {Icon}
      </div>
    );
  }
);

IconButton.displayName = "IconButton";

export default IconButton;
